class Accordion {
  accordionNode;
  accordionItems;
  currentItem;

  constructor(accordion) {
    this.accordionNode = accordion;
    this.accordionItems = this.accordionNode.querySelectorAll('.subsegments-item');
    this.accordionDescription = this.accordionNode.querySelectorAll('.subsegments-item__description');
    this.currentItem = this.accordionItems[0];

    // Establecer el estado inicial de los items
    this.setInitialItemState();

    this.showItem(this.currentItem);

    [...this.accordionItems].forEach((accordion, index) => {
      accordion.addEventListener('click', function (ev) {
        ev.preventDefault();
        let accordionExpanded = (accordion.getAttribute('aria-expanded') === 'true');

        if (!accordionExpanded) {
          this.showItem(accordion);
          this.scrollToAccordionHeader(accordion);
        } else {
          if (window.innerWidth < 992) {
            this.hideItem(accordion);
          }
          if (window.innerWidth > 991) {
            this.showItem(accordion);
            this.scrollToAccordionHeader(accordion);
          }
        }
      }.bind(this), false);
    });

    this.updateAccordionClasses();
  }

  // Establecer el estado inicial de todos los items
  setInitialItemState = () => {
    [...this.accordionItems].forEach(item => {
      const inner = item.querySelector('.subsegments-item__inner');
      inner.style.height = '0';
      inner.style.opacity = '0';
      inner.style.transition = 'height 0.5s ease-out, opacity 0.5s ease-out';
    });
  };

  updateAccordionClasses = () => {
    const numItems = this.accordionItems.length;
    this.accordionNode.classList.add(`has-${numItems}`);
  }

  showItem = (accordion) => {
    accordion.setAttribute('aria-expanded', true);
    accordion.querySelector('.subsegments-item__inner').setAttribute('aria-hidden', false);

    const inner = accordion.querySelector('.subsegments-item__inner');
    inner.style.transition = 'max-height 0.5s ease-out, opacity 0.5s ease-out';
    inner.style.maxHeight = inner.scrollHeight + 'px';
    inner.style.opacity = '1';

    const index = [...this.accordionItems].indexOf(accordion);
    this.accordionNode.classList.add(`expanded-${index}`);

    if (window.innerWidth > 991) {
      accordion.disabled = true;
      [...this.accordionItems].forEach((item, index) => {
        if (item !== accordion) {
          this.hideItem(item);
        }
      });
    }
  }

  hideItem = (accordion) => {
    if (window.innerWidth > 991) {
      accordion.disabled = false;
    }
    if (accordion.getAttribute('aria-expanded') === 'true') {
      accordion.setAttribute('aria-expanded', false);
      accordion.querySelector('.subsegments-item__inner').setAttribute('aria-hidden', true);
      accordion.querySelector('.subsegments-item__inner').setAttribute('tabindex', "-1");

      const inner = accordion.querySelector('.subsegments-item__inner');
      inner.style.transition = 'max-height 0.5s ease-out, opacity 0.5s ease-out';
      inner.style.maxHeight = '0';
      inner.style.opacity = '0';
    }

    const index = [...this.accordionItems].indexOf(accordion);
    this.accordionNode.classList.remove(`expanded-${index}`);
  }

  scrollToAccordionHeader = (accordion) => {
    const header = accordion.querySelector('.subsegments-item__header');
    if (header) {
      header.scrollIntoView({
        behavior: 'smooth',
        block: 'start',
      });
    }
  }
}

const initAccordions = () => {
  let accordions = document.querySelectorAll('.subsegments__accordion');
  for (let accordion of accordions) {
    new Accordion(accordion);
  }
}

window.onload = function () {
  initAccordions();
}
